module.exports = __webpack_public_path__ + "static/media/19ESCAP48.6a07dccd.jpg";